// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2Z4Xc","row":"ProcedureTreatmentSummary_row__t7aPg"};